import _extends from '../../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { forwardRef, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import { useThemeContext } from '../../ThemeProvider/ThemeContext.js';
import btnLoading from '../../../styles/btnLoading.js';
import { invisible } from '../../../styles/layout/invisible.js';
import ButtonBase from './ButtonBase.js';

var ButtonLoading = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      theme = props.theme,
      loadingStyle = props.loadingStyle,
      otherProps = _objectWithoutProperties(props, ["children", "theme", "loadingStyle"]);

  var themeTokens = useThemeContext();
  var loadingObject = useMemo(function () {
    return merge.all([btnLoading.btnLoading, btnLoading.keyframesSpinnerIndeterminate, loadingStyle ? btnLoading[loadingStyle] : btnLoading.btnPrimary_btnLoading, loadingStyle && loadingStyle !== 'btnPrimary_btnLoading' && themeTokens.primaryColor ? {
      '&::before': {
        borderLeftColor: themeTokens.primaryColor
      }
    } : {}]);
  }, [loadingStyle, themeTokens]);
  var completeStyleObject = merge.all([loadingObject, theme]);
  return jsx(ButtonBase, _extends({}, otherProps, {
    theme: completeStyleObject,
    ref: ref
  }), jsx("span", {
    css: invisible
  }, children));
});
ButtonLoading.displayName = 'ButtonLoading';
ButtonLoading.defaultProps = {
  children: '',
  loadingStyle: undefined,
  type: 'button',
  theme: {}
};

export default ButtonLoading;
